export default "__VITE_ASSET__6qMzqoX0__"